import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.to-string.js";
import { getServerList } from '@/api/data';
export var gameServer = {
  namespaced: true,
  state: {
    isInit: 0,
    serverKv: {},
    serverDetail: {}
  },
  mutations: {
    setServerKv: function setServerKv(state, serverMap) {
      state.isInit = 1;
      state.serverKv = serverMap;
    },
    setServerDetail: function setServerDetail(state, serverMap) {
      state.serverDetail = serverMap;
    }
  },
  actions: {
    getServer: function getServer(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, serverMap, serverDetailMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return getServerList();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                serverMap = {};
                serverDetailMap = {};
                res.data.forEach(function (val) {
                  serverMap[val.id.toString()] = val.label;
                  serverDetailMap[val.id.toString()] = val;
                });
                // dictionaryMap[res.data.resysDictionary.type] = dict
                commit("setServerKv", serverMap);
                commit("setServerDetail", serverDetailMap);
                // return state.dictionaryMap[type]
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    serverMap: function serverMap(state) {
      return state.serverKv;
    },
    serverDetail: function serverDetail(state) {
      return state.serverDetail;
    }
  }
};